import { computed } from "vue";

import { useWorkspace } from "@/store/workspace";

// The modules a user navigates records in: everything but the settings modules, and only where the
// module itself is active for them. Shared by the module list and the trash bin so the two offer the
// same set — recordservice.SoftDeleteRecords relies on settings-module records never reaching the
// bin, and hard-deletes them instead.
export function useNavigableModules() {
  const workspace = useWorkspace();

  return computed(
    () =>
      workspace.modules?.filter(
        (module) => !module.settingsModule && workspace.getModulePermissions(module.id).active === true,
      ) ?? [],
  );
}
